import React, { useEffect, useState } from "react";
import { ComparisonInputFilter, DateRangeFilter, PillChoiceFilter, PillMultiChoiceFilter, SelectFilter, BooleanChoiceFilter, SelectorWithPillsFilter, AsyncSelectorWithPillsFilter } from "./filter_types";
import { SvgFilterDelete, SvgSearch, SvgFilter } from "../svg";
import { Button } from '../../components/button';


const getFilterTypeByKey = (key, filterTypes) => {
    return filterTypes.find(f => f.key === key)
}

const Filters = (props) => {

    const [showFilters, setShowFilters] = useState(props.showFilter || false)

    const {
        activeFilters,
        filterTypes,
        addFilter,
        replaceFilter,
        changeFilterValue,
        removeFilter,
        updateSearchFilter
    } = props

    const RenderFilter = (filter, i) => {
        const filterType = getFilterTypeByKey(Object.keys(filter)[0], filterTypes)
        switch (filterType.type) {
            case 'choice':
                return (
                    <PillChoiceFilter
                        key={i}
                        name={filterType.key}
                        filterValue={filter[filterType.key]}
                        filterType={filterType}
                        removeFilter={() => removeFilter(i)}
                        changeFilterValue={changeFilterValue}
                    />
                )
            case 'multichoice':
                return (
                    <PillMultiChoiceFilter
                        key={i}
                        name={filterType.key}
                        filterValue={filter[filterType.key]}
                        filterType={filterType}
                        removeFilter={() => removeFilter(i)}
                        changeFilterValue={changeFilterValue}
                    />
                )
            case 'select':
                return (
                    <SelectFilter
                        key={i}
                        name={filterType.key}
                        filterValue={filter[filterType.key]}
                        filterType={filterType}
                        removeFilter={() => removeFilter(i)}
                        changeFilterValue={changeFilterValue}
                    />
                )
            case 'pillselector':
                return (
                    <SelectorWithPillsFilter
                        key={i}
                        name={filterType.key}
                        filterValue={filter[filterType.key]}
                        filterType={filterType}
                        removeFilter={() => removeFilter(i)}
                        changeFilterValue={changeFilterValue}
                    />
                )
            case 'async_pillselector':
                return (
                    <AsyncSelectorWithPillsFilter
                        key={i}
                        name={filterType.key}
                        filterValue={filter[filterType.key]}
                        filterType={filterType}
                        removeFilter={() => removeFilter(i)}
                        changeFilterValue={changeFilterValue}
                        loadOptions={filterType.loadOptions}
                    />
                )
            case 'boolean':
                return (
                    <BooleanChoiceFilter
                        key={i}
                        name={filterType.key}
                        filterValue={filter[filterType.key]}
                        filterType={filterType}
                        removeFilter={() => removeFilter(i)}
                        changeFilterValue={changeFilterValue}
                    />
                )
            case 'daterange':
                return (
                    <DateRangeFilter
                        key={i}
                        name={filterType.key}
                        filterValue={filter[filterType.key]}
                        filterType={filterType}
                        removeFilter={() => removeFilter(i)}
                        changeFilterValue={changeFilterValue}
                    />
                )
            case 'comparison_input':
                return (
                    <ComparisonInputFilter
                        key={i}
                        name={filterType.key}
                        filterValue={filter[filterType.key]}
                        filterType={filterType}
                        removeFilter={() => removeFilter(i)}
                        changeFilterValue={changeFilterValue}
                    />
                )
            default:
                return null
        }
    }

    const RenderFilterWrapper = (f, i) => {
        let availableFilters = []
        let currentFilter = null
        if (activeFilters.length > 0) {
            const activeFilterKeys = activeFilters.map(filter => Object.keys(filter)[0]);
            const currentFilterKey = f !== undefined ? Object.keys(f)[0] : undefined;
            availableFilters = filterTypes.filter(filter => !activeFilterKeys.includes(filter.key) || filter.key === currentFilterKey)
            currentFilter = filterTypes.find(filter => filter.key === currentFilterKey)
        } else {
            availableFilters = filterTypes;
        }
        const shouldRender = f !== undefined || availableFilters.length > 0;

        return (
            <>
                {shouldRender &&
                    <div key={i} className="filter">
                        <div className="row align-items-top">
                            <div className="col flex-grow-1 mb-xxl-0 mb-4 min-width-116">
                                <select className="form-select filtertype" defaultValue={f && Object.keys(f)[0]} onChange={(e) => { f ? replaceFilter(i, { [e.target.value]: '' }) : addFilter({ [e.target.value]: '' }) }}>
                                    {f == undefined && <option key="default" value="">{gettext('Filter by')}</option>}
                                    {availableFilters.map(filter =>
                                        <option key={filter.key} value={filter.key}>{filter.label}</option>
                                    )}
                                </select>
                            </div>
                            <div className="col-xxl-8">
                                {f &&
                                    <>
                                        {RenderFilter(f, i)}
                                        <span className="filter-delete" onClick={() => props.removeFilter(i)}><SvgFilterDelete /></span>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                }
            </>
        )
    }

    return (
        <>
            <div className="row">
                <div className="col flex-grow-1 search-container">
                    <input type="text" className="form-control" placeholder={gettext('Text search')} onChange={(e) => updateSearchFilter(e.target.value)} />
                    <SvgSearch />
                </div>
                <div className="col-2 min-width-116">
                    <Button variant={'outline-primary'} icon={<SvgFilter />} formControl={true} onClick={() => setShowFilters(!showFilters)}>
                        {gettext('Filter')}
                        {activeFilters.length > 0 && <span className="bubble">{activeFilters.length}</span>}
                    </Button>
                </div>
            </div>
            {showFilters &&
                <div className="row mt-3">
                    <div className="filters">
                        {activeFilters.filter((filter) => Object.keys(filter)[0] !== 'search').map((f, i) =>
                            RenderFilterWrapper(f, i)
                        )}
                        {RenderFilterWrapper(undefined, activeFilters.length)}
                    </div>
                </div>
            }
        </>
    )
}

export default Filters